import { apiInterfaceForJson } from "../common/apiManager";

export const fetchManagementActions = (params = {}) => {
    const query = new URLSearchParams();
    if (params.page) query.append("page", params.page);
    if (params.limit) query.append("limit", params.limit);
    if (params.actionType) query.append("actionType", params.actionType);
    if (params.performedBy) query.append("performedBy", params.performedBy);
    if (params.dateFrom) query.append("dateFrom", params.dateFrom);
    if (params.dateTo) query.append("dateTo", params.dateTo);
    if (params.isUndone !== undefined) query.append("isUndone", params.isUndone);

    const qs = query.toString();
    return apiInterfaceForJson(`/managementAction${qs ? `?${qs}` : ""}`, "GET");
};

export const exportManagementActions = (params = {}) => {
    const query = new URLSearchParams();
    if (params.actionType) query.append("actionType", params.actionType);
    if (params.performedBy) query.append("performedBy", params.performedBy);
    if (params.dateFrom) query.append("dateFrom", params.dateFrom);
    if (params.dateTo) query.append("dateTo", params.dateTo);
    if (params.isUndone !== undefined) query.append("isUndone", params.isUndone);

    const qs = query.toString();
    return apiInterfaceForJson(`/managementAction/export${qs ? `?${qs}` : ""}`, "GET");
};

export const undoManagementAction = (id) => {
    return apiInterfaceForJson(`/managementAction/undo/${id}`, "POST");
};
